import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/components/ThemeProvider';
import { BrandingProvider } from '@/context/BrandingContext';
import { lazy, Suspense } from 'react';
import '@/App.css';

// Lazy load all pages for faster initial load
const Home = lazy(() => import('@/pages/Home'));
const Confirmation = lazy(() => import('@/pages/Confirmation'));
const FAQ = lazy(() => import('@/pages/FAQ'));
const ManageBooking = lazy(() => import('@/pages/ManageBooking'));
const OurFleet = lazy(() => import('@/pages/OurFleet'));
const AboutUs = lazy(() => import('@/pages/AboutUs'));
const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('@/pages/TermsConditions'));
const AdminLogin = lazy(() => import('@/pages/AdminLogin'));
const AdminDashboard = lazy(() => import('@/pages/AdminDashboard'));
const DriverLogin = lazy(() => import('@/pages/driver/DriverLogin'));
const DriverRegister = lazy(() => import('@/pages/driver/DriverRegister'));
const DriverDashboard = lazy(() => import('@/pages/driver/DriverDashboard'));
const TrackTrip = lazy(() => import('@/pages/TrackTrip'));
const Book = lazy(() => import('@/pages/Book'));
const Services = lazy(() => import('@/pages/Services'));
const Contact = lazy(() => import('@/pages/Contact'));
const Rates = lazy(() => import('@/pages/Rates'));

// Minimal loading spinner - Legacy Limousine style
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#192537]">
    <div className="text-center">
      <div className="w-10 h-10 border-2 border-[#B09E80] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-white/50 text-sm tracking-wider uppercase">Loading</p>
    </div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <BrandingProvider>
          <div className="App">
            <BrowserRouter>
              <Suspense fallback={<PageLoader />}>
                <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/confirmation" element={<Confirmation />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/manage-booking" element={<ManageBooking />} />
                <Route path="/our-fleet" element={<OurFleet />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-conditions" element={<TermsConditions />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="/driver/login" element={<DriverLogin />} />
                <Route path="/driver/register" element={<DriverRegister />} />
                <Route path="/driver/dashboard" element={<DriverDashboard />} />
                <Route path="/track/:trackingCode" element={<TrackTrip />} />
                <Route path="/book" element={<Book />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/rates" element={<Rates />} />
                </Routes>
              </Suspense>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
          </div>
        </BrandingProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
